import { ERROR_CODES } from '@nomiss/constants';

export const SESSION_SUPERSEDED_ERROR_CODE = ERROR_CODES.AUTH_SESSION_SUPERSEDED;
export const ACCOUNT_BLOCKED_ERROR_CODE = ERROR_CODES.AUTH_ACCOUNT_BLOCKED;

export type MobileLogoutReason = 'expired' | 'superseded' | 'blocked';

type AuthErrorBody = {
  errorCode?: string;
  message?: string;
};

export async function getAuthErrorFromResponse(
  response: Response,
): Promise<AuthErrorBody | null> {
  try {
    return (await response.json()) as AuthErrorBody;
  } catch {
    return null;
  }
}

export function logoutReasonFromErrorCode(
  errorCode: string | undefined,
): MobileLogoutReason {
  if (errorCode === ACCOUNT_BLOCKED_ERROR_CODE) {
    return 'blocked';
  }
  if (errorCode === SESSION_SUPERSEDED_ERROR_CODE) {
    return 'superseded';
  }
  return 'expired';
}

export async function isSessionSupersededResponse(
  response: Response,
): Promise<boolean> {
  const body = await getAuthErrorFromResponse(response);
  return body?.errorCode === SESSION_SUPERSEDED_ERROR_CODE;
}

export async function resolveMobileLogoutReason(
  response: Response,
): Promise<MobileLogoutReason> {
  if (response.status !== 401) {
    return 'expired';
  }

  const body = await getAuthErrorFromResponse(response);
  return logoutReasonFromErrorCode(body?.errorCode);
}
